import { useContext } from 'react'
import { MODERATORS } from '../../../constants/chatRooms'
import { PRODUCT_MAP } from '../../../constants/products'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import LogoIcon from '../../../graphics/LogoIcon'
import { useViewportHeight } from '../../../hooks/useViewportHeight'
import { setPageTitle } from '../../../utils/utilities'
import HighlightedPM from '../../Layout/VideoSection/HighlightedPM'
import MessageList from '../../Messages/MessageList'
import Tooltip from '../../Utilities/Tooltip'

const PrivateChatHistory = () => {
  const { productsService } = useContext(SiteConfigContext)
  const product = productsService[PRODUCT_MAP.THIS_PRODUCT]
  useViewportHeight()
  setPageTitle('Private Chat History')
  return (
    <div className="flex h-full w-full flex-col gap-2">
      <div className="flex items-center">
        <h2 className="mr-3">Private Chat History</h2>
        <Tooltip>
          View the private message history here. If a message is highlighted on
          stream, it will appear above the chat log. Sending a message below
          broadcasts a global direct message to all users.
        </Tooltip>
      </div>
      <h4 className="flex items-center gap-2">
        <LogoIcon product={product?.itemNumber} />
        This feed only shows private messages sent from
        <span className="bg-brand-primary-800 text-brand-primary-50 px-1.5 rounded inline-flex items-baseline gap-1 text-base uppercase">
          {product?.displayName}
        </span>
      </h4>
      <HighlightedPM onHistory />
      <MessageList channel={MODERATORS} modView={true} history />
    </div>
  )
}

export default PrivateChatHistory
